export const donationDetailNpoFreeTour = {
  tourKey: 'donation_detail_npo_free',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['free'],
  },
  steps: [
    {
      target: '[data-tour="donation-claim-button"]',
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.claim.content',
      placement: 'left',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-claim-button"]')),
    },
    {
      target: '[data-tour="donation-assign-driver-button"]',
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.assign-driver.content',
      placement: 'top',
      autoOpenSelector: '[data-tour-claim-opens-driver-modal="true"]',
      showIf: () =>
        Boolean(
          document.querySelector('[data-tour-claim-opens-driver-modal="true"]')
        ),
    },
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.begin.content',
      placement: 'center',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-claim-button"]')),
    },
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.chat-or-call.content',
      placement: 'center',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-claim-button"]')),
    },
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.cancel-rescue.content',
      placement: 'center',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-claim-button"]')),
    },
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.update-weights.content',
      placement: 'center',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-claim-button"]')),
    },
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.reassign.content',
      placement: 'center',
      showIf: () =>
        !document.querySelector('[data-tour="donation-claim-button"]'),
    },
    {
      target: '[data-tour="donation-chat-button"]',
      title: 'tours.donation-detail-npo-free.chat.title',
      content: 'tours.donation-detail-npo-free.chat.content',
      placement: 'bottom',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-chat-button"]')),
    },
    {
      target: '[data-tour="donation-cancel-button"]',
      title: 'tours.donation-detail-npo-free.cancel.title',
      content: 'tours.donation-detail-npo-free.cancel.content',
      placement: 'bottom',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-cancel-button"]')),
    },
  ],
};
